// extracted by mini-css-extract-plugin
export default {"card":"specialCard_card__fwJhd","title":"specialCard_title__zpzYG"};